import React from "react";

const Confirmed = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_12705_39820)">
<path d="M7.9987 14.6654C11.6806 14.6654 14.6654 11.6806 14.6654 7.9987C14.6654 4.3168 11.6806 1.33203 7.9987 1.33203C4.3168 1.33203 1.33203 4.3168 1.33203 7.9987C1.33203 11.6806 4.3168 14.6654 7.9987 14.6654Z" fill="#FF2626" stroke="#FF2626" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5 8L7 10L11 6" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_12705_39820">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
);

export default Confirmed;
